import { render, staticRenderFns } from "./GlobalSideBarLink.vue?vue&type=template&id=76dc983a&scoped=true"
import script from "./GlobalSideBarLink.vue?vue&type=script&lang=js"
export * from "./GlobalSideBarLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dc983a",
  null
  
)

export default component.exports